module.exports = __webpack_public_path__ + "static/media/screenshot.881d66db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/YwamShowcasePhone/screenshot.jpg
// module id = 237
// module chunks = 0